module.exports = __webpack_public_path__ + "static/media/sigfoxbl.13b601de.jpeg";